import { render, staticRenderFns } from "./AccomplishmentScaleTable.vue?vue&type=template&id=1920fcf0"
import script from "./AccomplishmentScaleTable.vue?vue&type=script&lang=js"
export * from "./AccomplishmentScaleTable.vue?vue&type=script&lang=js"
import style0 from "./AccomplishmentScaleTable.vue?vue&type=style&index=0&id=1920fcf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports